module.exports = "/assets/js/964f0adc79163c8b1d0065268d717612.svg";